/**
 * Whether an email address is well formed (owner request, 2026-10-15: the users screen blocks
 * "Add user" otherwise). Spaces around it are ignored; inside, none is allowed. One "@", something
 * before it, and a domain of dot-separated parts ending in at least two letters.
 */
export function isValidEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@.]+(\.[^\s@.]+)*\.[^\s@.]{2,}$/.test(email.trim());
}
